import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  @ViewChild('searchHero', { static: true }) search: Input;

  constructor( private router: Router ) { }

  ngOnInit(): void {

  }

  searchHero(term: string) {
    // console.log(term);
    if (term.length > 0) {
      this.router.navigate( ['/search', term] )
    } else {
      this.router.navigate( ['/heroes'] )
    }
  }

}
